////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { find, sample } from 'lodash'
import { shallowEqual, useSelector } from 'react-redux'
///////COMPONENTS///////
import StringFormatter from '../../../../helpers/StringFormatter'
/////////ASSETS/////////
import PriceFormatter from '../../../../helpers/PriceFormatter'
import ErrorAlert from '../../../../assets/icones/global/warning-red.svg'
import InfoAlert from '../../../../assets/icones/global/info-big-blue.svg'

//////STYLED//////
const BodyCells = styled.td`
	display: table-cell;
	text-align: center;
	background-color: inherit;
	height: 60px;
	box-sizing: border-box;
	padding: 5px 5px;
	border-top: 1px solid ${(props) => props.theme.colors.table.borderTable};
`
const BodyCellsRightBorder = styled(BodyCells)`
	border-right: 1px solid ${(props) => props.theme.colors.table.borderTable};
`
const ColorSpan = styled.span`
	color: #0885d5;
`
const InputTableRow = styled.input`
	padding: 5px;
	width: 80px;
	text-align: center;
`
const ErrorFormCampaign = styled.div`
	display: flex;
	justify-content: center;
	align-content: center;
	align-items: center;
	background-color: ${(props) => props.theme.colors.errorlight};
	padding: 10px;
	border-radius: 5px;
`
const InfoFormCampaign = styled.div`
	display: flex;
	justify-content: center;
	align-content: center;
	align-items: center;
	background-color: ${(props) => props.theme.colors.info};
	padding: 10px;
	border-radius: 5px;
	color: ${(props) => props.theme.colors.primary};
`
const LineInfoImg = styled.img`
	max-height: 20px;
	margin-right: 10px;
`
//////STYLED//////

const PromoCampaignUpdateSecondLine = (props) => {
	const currency = props.column[0].currency || '$'
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	const [conversionSales, setConversionSales] = useState({ convert: 0, initial: 0 })

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleWithVAT = (_withVAT, value, taxesRate) => {
		setConversionSales({ convert: PriceFormatter.vatConverter(withVAT, value, taxesRate), initial: value })
	}

	const withVAT = props.column[0]?.withTaxes || false
	const errorsLine = props.column[0].errors.priceValue ? sample(props.column[0].errors.priceValue[props.row.lineNumber]) || false : false
	const errorsCalls = find(props.column[0].callErrors, { lineNumber: props.row.lineNumber }) || props.row.errorDto || false
	const inputPrice = PriceFormatter.stringToNumberInput(props.row.standardPrice)
	const inputDepositPrice = PriceFormatter.stringToNumberInput(props.row.depositPrice)

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (typeof props.row.standardPriceVATRate === 'string') {
			handleWithVAT(!withVAT, conversionSales.initial, props.row.standardPriceVATRate)
		}
	}, [props.column[0].withTaxes])

	useEffect(() => {
		if (typeof props.row.standardPriceVATRate === 'string') {
			handleWithVAT(!withVAT, inputPrice, props.row.standardPriceVATRate)
		}
	}, [])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<>
			<BodyCellsRightBorder>
				<ColorSpan>{translations['page__promotionManagement__creation_table_newValues']}</ColorSpan>
			</BodyCellsRightBorder>
			<BodyCells colSpan="5">
				{errorsLine || errorsCalls ? (
					<ErrorFormCampaign>
						<LineInfoImg src={ErrorAlert} />
						{errorsLine
							? errorsLine.message
							: errorsCalls &&
							  StringFormatter.ResponseMessageParser(translations[errorsCalls.traductionKey], errorsCalls.msgParameters)}
					</ErrorFormCampaign>
				) : (
					<InfoFormCampaign>
						<LineInfoImg src={!props.column[0].isStarted && InfoAlert} />
						{!props.column[0].isStarted
							? translations['modal__pricesManagement__pricesCampaign_creation_newValues_message']
							: translations['page__promotionManagement__update_table_newValues_message']}
					</InfoFormCampaign>
				)}
			</BodyCells>
			<BodyCells>
				<InputTableRow
					type="number"
					defaultValue={inputPrice || 0}
					disabled={props.column[0].isStarted}
					min={0}
					onBlur={(e) => handleWithVAT(!withVAT, e.target.value, props.row.standardPriceVATRate)}
					name={`priceValue.${props.row.lineNumber}.actualStandardPrice`}
					ref={props.column[0].register({
						min: { value: 0, message: translations['common__message__price_minimum'] },
						max: { value: 9999, message: translations['common__message__price_maximum'] },
						required: { value: true, message: translations['common__text__requiredField'] },
						pattern: { value: /^[\d]*[\{.,,}]?\d{0,2}$/, message: translations['common__message__price_decimalMax'] },
					})}
				/>
			</BodyCells>
			<BodyCells>{`${conversionSales.convert}${currency}`}</BodyCells>
			<BodyCells>
				<InputTableRow
					type="number"
					defaultValue={inputDepositPrice || 0}
					min={0}
					disabled={/*isNull(props.row.depositPrice) ||  */ props.column[0].isStarted}
					name={`priceValue.${props.row.lineNumber}.actualDepositPrice`}
					ref={props.column[0].register({
						min: { value: 0, message: translations['common__message__price_minimum'] },
						max: { value: 9999, message: translations['common__message__price_maximum'] },
						required: { value: true, message: translations['common__text__requiredField'] },
						pattern: { value: /^[\d]*[\{.,,}]?\d{0,2}$/, message: translations['common__message__price_decimalMax'] },
					})}
				/>
			</BodyCells>
			<BodyCells>
				<InputTableRow
					type="number"
					defaultValue={props.row.quantity || 0}
					disabled={props.column[0].isStarted}
					min={0}
					name={`priceValue.${props.row.lineNumber}.quantity`}
					ref={props.column[0].register({
						min: { value: 0, message: translations['common__message__price_minimum'] },
						max: { value: 9999, message: translations['common__message__price_maximum'] },
						required: { value: true, message: translations['common__text__requiredField'] },
						pattern: { value: /(?<=\s|^)\d+(?=\s|$)/, message: translations['common__text__positiveInteger'] },
					})}
				/>
			</BodyCells>
			<BodyCells>
				<p>-</p>
			</BodyCells>
		</>
	)
}

PromoCampaignUpdateSecondLine.propTypes = {}

PromoCampaignUpdateSecondLine.defaultPropTypes = {}

export default PromoCampaignUpdateSecondLine
